import type { HttpGet } from '@/shared/infra/http'
import type { ListHuntOptions } from '@/shared/domain/use-cases'
import type { HuntOption } from '@/shared/domain'

const DEFAULT_LIMIT = 100

export class EdgeListHuntOptionsRepository {
  constructor(private readonly http: HttpGet) {}

  execute: ListHuntOptions = async (params) => {
    const query = new URLSearchParams()
    query.set('orgId', params.orgId)
    query.set('orgType', params.orgType)
    query.set('limit', String(params.limit ?? DEFAULT_LIMIT))

    const result = await this.http.get<{ hunts: Record<string, unknown>[] }>({
      url: `/hunts?${query.toString()}`,
    })

    return result.hunts.reduce<HuntOption[]>((options, hunt) => {
      const id = hunt.huntId
      const title = hunt.title
      const date = hunt.date
      if (
        typeof id === 'string' &&
        typeof title === 'string' &&
        typeof date === 'string'
      ) {
        options.push({ id, title, date })
      }
      return options
    }, [])
  }
}
